import validate from 'validate.js'
const constraints = {

}

export default fields =>  validate(fields, constraints, {fullMessages: false}) || {}
